import styled from 'styled-components';
import { Card } from 'antd';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  LoadingOutlined,
} from '@ant-design/icons';
import { blue, gold, green, red } from '@ant-design/colors';

// Card with vertical spacing so it separates from the tariff buttons above and
// the CBP Description field below.
export const StyledCard = styled(Card)`
  margin-top: ${({ theme }) => theme.spacing.space_3};
  margin-bottom: ${({ theme }) => theme.spacing.space_5};
`;

// Icon colors come from the antd color palette (tokens, not hardcoded hex),
// matching the existing PgaDisclaimAiStatus convention.
export const PassedIcon = styled(CheckCircleFilled)`
  color: ${green.primary};
`;

export const FailedIcon = styled(CloseCircleFilled)`
  color: ${red.primary};
`;

// Amber warning icon for the SYSTEM_ERROR (technical issue) state.
export const WarningIcon = styled(ExclamationCircleFilled)`
  color: ${gold.primary};
`;

// Blue (processing) spinner for the in-progress state.
export const SpinnerIcon = styled(LoadingOutlined)`
  color: ${blue.primary};
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.space_4};
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.space_2};
`;

export const RecommendationLabel = styled.div`
  margin-top: ${({ theme }) => theme.spacing.space_3};
`;

export const ChipRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.space_2};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const ActionRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-top: ${({ theme }) => theme.spacing.space_3};
`;

// Secondary status section (e.g. HTS Validation Passed) shown below the
// reasonability status once the HTS recommendation is accepted/validated.
export const ValidationSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.space_4};
`;
